import React from 'react';
import { Clock, Plus, CheckCircle, Users, TrendingUp, Tag } from 'react-feather';
import './ActivitySummary.css';

const ActivitySummary = ({ summary }) => {
    if (!summary) return null;

    const statCards = [
        {
            label: 'Total Hours',
            value: `${summary.totalHours || 0}h`,
            icon: <Clock size={20} />,
            color: 'info'
        },
        {
            label: 'Tasks Created',
            value: summary.tasksCreated || 0,
            icon: <Plus size={20} />,
            color: 'success'
        },
        {
            label: 'Tasks Completed',
            value: summary.tasksCompleted || 0,
            icon: <CheckCircle size={20} />,
            color: 'success'
        },
        {
            label: 'Status Changes',
            value: summary.statusChanges || 0,
            icon: <TrendingUp size={20} />,
            color: 'warning'
        },
        {
            label: 'Active Users',
            value: summary.activeUsers || 0,
            icon: <Users size={20} />,
            color: 'info'
        }
    ];

    return (
        <div className="activity-summary">
            <div className="activity-summary-grid">
                {statCards.map((stat, index) => (
                    <div key={index} className={`activity-summary-card activity-summary-card-${stat.color}`}>
                        <div className="activity-summary-icon">
                            {stat.icon}
                        </div>
                        <div className="activity-summary-content">
                            <div className="activity-summary-value">{stat.value}</div>
                            <div className="activity-summary-label">{stat.label}</div>
                        </div>
                    </div>
                ))}
            </div>
            
            {summary.topTasks && summary.topTasks.length > 0 && (
                <div className="activity-summary-section">
                    <h4 className="activity-summary-section-title">
                        <TrendingUp size={16} />
                        Most Active Tasks
                    </h4>
                    <div className="activity-summary-tasks">
                        {summary.topTasks.map((task, index) => (
                            <div key={task.task_id} className="activity-summary-task-item">
                                <span className="activity-summary-task-rank">#{index + 1}</span>
                                <span className="activity-summary-task-id">{task.task_display_id || 'N/A'}</span>
                                <span className="activity-summary-task-title">{task.task_title}</span>
                                <span className="activity-summary-task-hours">{task.totalHours}h</span>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {summary.featureActivity && summary.featureActivity.length > 0 && (
                <div className="activity-summary-section">
                    <h4 className="activity-summary-section-title">
                        <Tag size={16} />
                        Feature Activity
                    </h4>
                    <div className="activity-summary-features">
                        {summary.featureActivity.slice(0, 5).map((feature) => (
                            <div key={feature.feature_id} className="activity-summary-feature-item">
                                <span 
                                    className="activity-summary-feature-color"
                                    style={{ backgroundColor: feature.feature_color || '#6B7280' }}
                                />
                                <span className="activity-summary-feature-name">{feature.feature_name}</span>
                                <span className="activity-summary-feature-count">{feature.activityCount} activities</span>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ActivitySummary;
